import BaseService from '../../base/base_service';
import _ from '../../utils/underscore';
import IConfigService from './config_service_interface';

const STOP_CONFIGS: string[] = []; //ex.["defaults.logLevel", "Language.iso3", "Initialize.logLevel"]

class ConfigService extends BaseService implements IConfigService{

  static CLASS: string = 'ConfigService';
  private _configs: any[] = [];

  init(params) {
    super.init(params);
    if (this._configs.length === 0) {
      this._pushQueryStringParameters();
    }
  }

  //Push parameters coming from query String as highest priority
  private _pushQueryStringParameters(): void {
    const queryParams = this._convertToObject(_.getQueryParameters());

    this._pushConfig(9999, this._cleanConfig(queryParams));

  }

  private _convertToObject(params: any): any {
    const obj = {};

    Object.keys(params).forEach(param=> {
      const val = params[param];
      const miniObj = param.split('.').reduceRight((prev, key, idx, arr)=> {
          const newObj = {};
          newObj[key] = prev;

          if (idx === arr.length - 1) {
            newObj[key] = val;
          }

          return newObj;
        }, {});

      _.mergeDeep(obj, miniObj);
    });

    return obj;
  }

  private _pushConfig(level: number, config: any): any[] {
    if (this._configs[level]) {
      throw new Error("Config Level already set!");
    }
    this._configs[level] = config;
    return this._configs;
  }

  private _cleanConfig(config: any) {
    STOP_CONFIGS.forEach(stop => {
      config = this._deleteByPath(config, stop);
    });
    return config;
  }

  private _deleteByPath(object: any, path: string): any {
    let currentObject = object;
    const nestedProperties = path.split(".");
    const lastProperty = nestedProperties.pop();
    for (const property of nestedProperties) {
      currentObject = currentObject[property];
      if (!currentObject) {
        return;
      }
    }
    delete currentObject[lastProperty];
    return object;
  }

  //Setter User Config from  CGP.initialize({}).
  public setUserConfig(config: any): void {
    this._pushConfig(1, this._cleanConfig(config));
  }

  //Setter Config from Server Configurations
  public setDefaultConfig(config: any): void {
    this._pushConfig(0, config);
  }

  //Get merged Configs
  public getConfig(): any {
    const configValues = Object.keys(this._configs).map(key => this._configs[key]);

    configValues.unshift({});

    return _.mergeDeep.apply(_, configValues);
  }
}

export default ConfigService;